document.querySelectorAll('button.video-play').forEach((button) => {
  button.addEventListener('click', () => {
      const container = button.closest('.testimonial-video')
      const preview = container?.querySelector('video')
      const src = preview?.querySelector('source')?.src || preview?.currentSrc
      const modal = document.querySelector('.testimonial-videos__modal')
      const video = modal?.querySelector('video')
      if (!src || !video) return

      let source = video.querySelector('source')
      if (!source) {
          source = document.createElement('source')
          source.type = 'video/mp4'
          video.appendChild(source)
      }
      source.src = src
      video.load()
      video.play()
      modal.classList.add('is-open')
  })
})

document.querySelectorAll('.testimonial-videos__modal').forEach((modal) => {
  modal.querySelector('.testimonial-video__modal-close')?.addEventListener('click', () => {
      const video = modal.querySelector('video')
      if (video) video.pause()
      modal.classList.remove('is-open')
  })
})
